"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastModified = exports.ByUser = exports.HcmsActorHelper = exports.HcmsActorType = exports.makeCustomSelectPicker = exports.makeUsersFilter = exports.makeDateRangeFilter = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _Autocomplete = _interopRequireDefault(require("../Autocomplete"));

var _DateTimeRange = _interopRequireDefault(require("../DateTimeRange"));

var _DateHelper = require("./DateHelper");

var _Avatar = _interopRequireDefault(require("../Avatar"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _DateComponents = require("./DateComponents");

var _StringHelper = require("./StringHelper");

/**
 *
 * @param fieldName Name of the field being filtered on
 * @param orgTimeZone Organization Time Zone set in the Platform
 * @param dateOnly Only dates instead of DateTime
 * @param clientSideLogic is a function which send `true` to AdvancedTable when the row should be filtered out
 */
var makeDateRangeFilter = function makeDateRangeFilter(fieldName, orgTimeZone, dateOnly, clientSideLogic) {
  var timeZone = orgTimeZone || "America/Chicago";
  return {
    filterType: "custom",
    customFilterListRender: function customFilterListRender(v) {
      if (!v || v.length < 1) {
        return;
      }

      if (v[0] && v[1]) {
        return "From ".concat((0, _DateHelper.toDateTimeZone)(v[0], timeZone, dateOnly), ", Until ").concat((0, _DateHelper.toDateTimeZone)(v[1], timeZone, dateOnly));
      }

      if (v[0]) {
        return "From ".concat((0, _DateHelper.toDateTimeZone)(v[0], timeZone, dateOnly), ", Until Now");
      }

      if (v[1]) {
        return "From Earliest, Until ".concat((0, _DateHelper.toDateTimeZone)(v[1], timeZone, dateOnly));
      }
    },
    filterOptions: {
      logic: clientSideLogic,
      display: function dateRangeFilter(filterList, _onChange, index, column) {
        return /*#__PURE__*/_react.default.createElement(_DateTimeRange.default, {
          id: "dateFilter-".concat(fieldName),
          label: fieldName,
          fromProps: {
            label: "From",
            fullWidth: true,
            maxValue: filterList[index][1] ? new Date(filterList[index][1]) : undefined
          },
          toProps: {
            label: "Until",
            fullWidth: true,
            minValue: filterList[index][0] ? new Date(filterList[index][0]) : undefined
          },
          onChange: function onChange(e, value) {
            var oldFrom = filterList[index][0];
            var oldTo = filterList[index][1];
            filterList[index][0] = value.from || undefined;
            filterList[index][1] = value.to || undefined;

            if (oldFrom === filterList[index][0] && oldTo === filterList[index][1]) {
              return;
            }

            if (!value.from && !value.to) {
              filterList[index] = [];
            }

            _onChange(filterList[index], index, column);
          },
          pickerType: dateOnly ? "date" : "dateTime",
          format: dateOnly ? "MM/dd/yyyy" : "MM/dd/yyyy h:mm a",
          value: {
            from: filterList[index][0],
            to: filterList[index][1]
          }
        });
      }
    }
  };
};
/**
 *
 * @param fieldName Name of the field being filtered on
 * @param searchUsers Promise sent to search users
 * @param clientSideLogic is a function which send `true` to AdvancedTable when the row should be filtered out
 */


exports.makeDateRangeFilter = makeDateRangeFilter;

var makeUsersFilter = function makeUsersFilter(fieldName, searchUsers, clientSideLogic) {
  return {
    filterType: "custom",
    customFilterListRender: function customFilterListRender(values) {
      var renderValues = [];
      values.forEach(function (value) {
        renderValues.push(value.label);
      });
      return values.length ? "".concat(fieldName, ": ").concat(renderValues.join(", ")) : false;
    },
    filterOptions: {
      logic: clientSideLogic,
      display: function usersFilter(filterList, _onChange2, index, column) {
        return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
          id: "userFilter-".concat(fieldName, "-autocomplete"),
          label: fieldName,
          onChange: function onChange(value) {
            if (value === null) {
              value = [];
            }

            filterList[index] = value;

            _onChange2(filterList[index], index, column);
          },
          fullWidth: true,
          multiSelect: true,
          loadOptions: searchUsers,
          value: filterList[index],
          noOptionsMessage: "No users found.",
          isInDialog: true,
          openMenuWhenClicked: false
        });
      }
    }
  };
};
/**
 *
 * @param fieldName Name of the field being filtered on
 * @param values Autcomplete values to sent to the `Autocomplete` input component
 * @param clientSideLogic is a function which send `true` to AdvancedTable when the row should be filtered out
 */


exports.makeUsersFilter = makeUsersFilter;

var makeCustomSelectPicker = function makeCustomSelectPicker(fieldName, values, clientSideLogic) {
  return {
    filterType: "custom",
    customFilterListRender: function customFilterListRender(values) {
      var renderValues = [];
      values.forEach(function (value) {
        renderValues.push(value.label);
      });
      return values.length ? "".concat(fieldName, ": ").concat(renderValues.join(", ")) : false;
    },
    filterOptions: {
      logic: clientSideLogic,
      display: function customSelectPicker(filterList, _onChange3, index, column) {
        return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
          id: "filter-".concat(fieldName, "-autocomplete"),
          label: fieldName,
          onChange: function onChange(value) {
            if (value === null) {
              value = [];
            }

            filterList[index] = value;

            _onChange3(filterList[index], index, column);
          },
          multiSelect: true,
          fullWidth: true,
          options: values,
          value: filterList[index],
          isInDialog: true
        });
      }
    }
  };
};

exports.makeCustomSelectPicker = makeCustomSelectPicker;
var HcmsActorType;
exports.HcmsActorType = HcmsActorType;

(function (HcmsActorType) {
  HcmsActorType[HcmsActorType["Client"] = 0] = "Client";
  HcmsActorType[HcmsActorType["User"] = 1] = "User";
  HcmsActorType[HcmsActorType["Other"] = 2] = "Other";
})(HcmsActorType || (exports.HcmsActorType = HcmsActorType = {}));

var HcmsActorHelper = /*#__PURE__*/function () {
  function HcmsActorHelper() {
    (0, _classCallCheck2.default)(this, HcmsActorHelper);
  }

  (0, _createClass2.default)(HcmsActorHelper, null, [{
    key: "getActorFromRefToken",
    value: function getActorFromRefToken(token) {
      var senderIdSplit = token.split(":");

      switch (senderIdSplit[0]) {
        case "subject":
          return {
            type: HcmsActorType.User,
            id: senderIdSplit[1]
          };

        case "client":
          return {
            type: HcmsActorType.Client,
            id: senderIdSplit[2]
          };

        default:
          return {
            type: HcmsActorType.Other,
            id: senderIdSplit[0]
          };
      }
    }
  }]);
  return HcmsActorHelper;
}();

exports.HcmsActorHelper = HcmsActorHelper;

var ByUser = function ByUser(_ref) {
  var entity = _ref.entity,
      users = _ref.users;
  var userName = "";
  var userEmail;

  if (typeof entity === "string" && users) {
    var actor = typeof entity === "string" ? HcmsActorHelper.getActorFromRefToken(entity) : entity;
    var hcmsUser = users.has(entity) ? users.get(entity) : undefined;
    userName = hcmsUser && actor.type === HcmsActorType.User ? (0, _StringHelper.getUsersName)(hcmsUser) : actor.id;
    userEmail = hcmsUser && actor.type === HcmsActorType.User && hcmsUser.email ? hcmsUser.email : null;
  } else {
    userName = (0, _StringHelper.getUsersName)(entity);
    userEmail = entity && typeof entity !== "string" && entity.email ? entity.email : null;
  }

  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 0,
    direction: "row",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    id: "avatar-" + userName,
    size: "small",
    gutter: "right",
    name: userName,
    email: userEmail
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement("span", null, userName)));
};

exports.ByUser = ByUser;

var LastModified = function LastModified(_ref2) {
  var date = _ref2.date,
      organizationTimeZone = _ref2.organizationTimeZone;
  var props = {
    date: date,
    timeZone: organizationTimeZone,
    id: "lastModified"
  };
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    alignContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_DateComponents.RelativeDateTooltip, props));
};

exports.LastModified = LastModified;